<template>
  <div class="navBox">
    <img src="@/assets/image/logo.png" style="margin: 30px 0 0 38px" />
    <div>
      <div class="header_cen">
        <h3 class="header_tit">
          <!-- <img src="@/assets/image/gif/home.gif"> -->
          基于股票多因子策略模型的<br />量化金融虚拟仿真实验教学项目
        </h3>
        <span class="header_btn" @click="routeFun">开始</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listData: []
    };
  },
  methods: {
    routeFun() {
      if (this.$route.query.ticket) {
        this.$ILab.GetUserInfo();
      }
      this.$router.push({ path: "/homeNav" });
    }
  },
  created() {}
};
</script>
<style lang="less" scoped>
.navBox {
  background: url("../assets/image/banner/0.png") no-repeat center;
  height: 100%;
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  .header_cen {
    width: 1300px;
    margin: 0 auto;
    padding-top: 150px;
    .header_tit {
      font-size: 35px;
      color: #f7f9ff;
      line-height: 57px;
      text-shadow: 1px 4px 10px #0080ff;
      font-weight: 600;
      text-align: center;
      background: url("../assets/image/banner/a.png") no-repeat center;
      width: 100%;
      height: 208px;
      padding-top: 44px;
      img {
        height: 300px;
        width: 100%;
      }
    }
    .header_btn {
      width: 200px;
      height: 60px;

      border-radius: 11px;
      border: 2px solid #f7f9ff;
      display: block;
      font-size: 24px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: 500;
      color: #f7f9ff;
      text-align: center;
      line-height: 50px;
      margin: 0 auto;
      margin-top: 118px;
      cursor: pointer;
      background: #005581;
      transition: all 0.5s;
      -webkit-box-shadow: 0px 0px 27px 0px #57a3ef;
      box-shadow: 0px 0px 27px 0px #57a3ef;
    }
    .header_btn:hover {
      transform: scale(1.2);
    }
  }

  .centerLI {
  }
}
</style>
